<div class="segmented-input" [class.disabled]="isDisabled">
  @for (val of segmentValues; track trackByIndex($index); let i = $index) {
    @if (i > 0) {
      <span class="seg-separator">{{ separator }}</span>
    }
    <input
      #segInput
      class="seg-box"
      [class.grouped]="!!groupSize"
      [class.filled]="!!val"
      type="text"
      [attr.inputmode]="pattern === 'numeric' ? 'numeric' : 'text'"
      autocomplete="off"
      spellcheck="false"
      [attr.maxlength]="maxLengthFor()"
      [placeholder]="placeholderFor()"
      [disabled]="isDisabled"
      [value]="displayValue(val)"
      [style.--seg-len]="segmentLength"
      (input)="onInput($event, i)"
      (keydown)="onKeydown($event, i)"
      (paste)="onPaste($event, i)"
      (blur)="onBlur($event, i)"
    />
  }
</div>
